// app/javascript/controllers/donut_chart_controller.js
import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = {
    inputs: String,
    holeSize: String,
    borderRadius: { type: Number, default: 3 },
    borderWidth: { type: Number, default: 2 },
    animationDuration: { type: Number, default: 1000 },
    interactive: { type: Boolean, default: true },
  };
  static targets = ['chartcanvas'];
  static aspectRatio = 1;

  _buildChart() {
    // Marks the actual Chart.js render moment; ancestors can key intro animations off this via :has().
    this.element.classList.add('chart-loaded');

    const data = JSON.parse(this.inputsValue);
    const cutout = this.holeSizeValue || '70%';

    new Chart(this.chartcanvasTarget, {
      type: 'doughnut',
      data,
      options: {
        responsive: true,
        aspectRatio: this.constructor.aspectRatio,
        borderRadius: this.borderRadiusValue,
        borderWidth: this.borderWidthValue,
        cutout,
        animation: { duration: this.animationDurationValue },
        events: this.interactiveValue ? undefined : [],
        plugins: {
          tooltip: { enabled: false },
          legend: { display: false },
        },
      },
      plugins: [
        {
          id: 'centerText',
          afterDatasetsDraw(chart) {
            const { ctx, data } = chart;
            const text = data.donutCenterText || '';
            const { x, y } = chart.getDatasetMeta(0).data[0];
            ctx.save();
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '12px sans-serif';
            ctx.fillStyle = 'rgba(0,0,0,0.5)';
            ctx.fillText(text, x, y);
          },
        },
      ],
    });
  }
}
